import "core-js/modules/es.array.push.js";
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "amount-info"
};
const _hoisted_2 = {
  class: "cell"
};
const _hoisted_3 = {
  class: "left"
};
const _hoisted_4 = {
  class: "right"
};
const _hoisted_5 = {
  key: 0,
  class: "ticket-cell cell"
};
const _hoisted_6 = {
  class: "left"
};
const _hoisted_7 = {
  class: "left-item"
};
const _hoisted_8 = {
  class: "right"
};
const _hoisted_9 = {
  key: 1,
  class: "ticket-cell cell"
};
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", {
  class: "left"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "left-item"
}, /*#__PURE__*/_toDisplayString('Promotion saved'))], -1);
const _hoisted_11 = {
  class: "right"
};
const _hoisted_12 = {
  class: "price red-price"
};
const _hoisted_13 = {
  class: "cell"
};
const _hoisted_14 = {
  class: "left"
};
const _hoisted_15 = {
  class: "right"
};
const _hoisted_16 = {
  class: "cell"
};
const _hoisted_17 = {
  class: "left"
};
const _hoisted_18 = {
  class: "right"
};
const _hoisted_19 = {
  class: "reason"
};
const _hoisted_20 = {
  class: "unline"
};
const _hoisted_21 = {
  key: 1,
  class: "no-address"
};
const _hoisted_22 = {
  class: "cell-right"
};
import { ref, reactive, watch, computed, onMounted } from 'vue';
import { isLoginAuthenticated, getAppConfig } from '@/utils/common';
import PopUp from '@/components/popup/PopUp.vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import { getNewCustomerPromotions } from '@/models/api/promotionApi';
import { getCustomerActualPurchase } from '@/models/api/orderConfirmApi';
import { getPromotionInfosByPromotionIds, redeemPromotionForCurrentCustomer } from '@/models/api/promotionApi.js';
import { findOptimalPromotion, popUpType } from './SPCAccountingBox';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
import { useLess } from '@/models/hooks';
import { useI18n } from 'vue-i18n';
export default {
  __name: 'SPCAccountingBox',
  props: {
    price: {
      type: Object,
      default: () => {
        return {
          originalShippingFee: 0,
          shippingFee: 0,
          importFee: 0,
          total: 0,
          discount: 0,
          promotionList: []
        };
      }
    },
    promotions: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
    addressInfo: {
      type: Object,
      default: () => null
    },
    isNewCustomer: {
      type: Boolean,
      default: () => false
    }
  },
  emits: ['updatePurchase', 'update:promotions', 'update:isNewCustomer'],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      COUPON_SERVICE_PROMOTION_STATUS,
      ENCRYPTED_MARKETPLACE_ID
    } = constants;
    useLess('views/spc/orderConfirm/components/SPCAccountingBox.less');
    const {
      t
    } = useI18n();
    const GREY_TIP = `${constants.IMAGE_URL}assets/svg/greyTip.svg`;
    const promotions = ref(null);
    const promotionIds = ref([]);
    const show = ref(false);
    const popText = reactive({});
    const cptIsNewCustomer = computed({
      get: () => props.isNewCustomer,
      set: val => {
        emit('update:isNewCustomer', val);
      }
    });
    const clickHandle = async type => {
      if (type === popUpType.CSF_DESC) {
        awsRumHandler.recordClickEvent(clickEvents.checkoutPage.showImportFeeButton);
      } else {
        awsRumHandler.recordClickEvent(clickEvents.checkoutPage.showShippingFeeButton);
      }
      const configData = await getAppConfig(constants.ENUM_APP_CONFIG_TYPE.CHECKOUT_PAGE);
      popText.title = configData[type].title;
      popText.content = configData[type].content;
      show.value = true;
    };
    const showCoupon = ref(false);
    const getPromotionInfo = async promotionId => {
      try {
        var _props$price;
        const {
          data
        } = await getPromotionInfosByPromotionIds(promotionId);
        const promotionList = data === null || data === void 0 ? void 0 : data.miniAppPromotionList.map(item => {
          var _item$thresholds$, _item$thresholds$$cur, _item$benefits$, _item$benefits$$fixed;
          return {
            id: item.encryptedPromotionId,
            text: item.optimizedShortMerchandisingMessage,
            threshold: (_item$thresholds$ = item.thresholds[0]) === null || _item$thresholds$ === void 0 ? void 0 : (_item$thresholds$$cur = _item$thresholds$.currencyAmount) === null || _item$thresholds$$cur === void 0 ? void 0 : _item$thresholds$$cur.amount,
            amount: (_item$benefits$ = item.benefits[0]) === null || _item$benefits$ === void 0 ? void 0 : (_item$benefits$$fixed = _item$benefits$.fixedAmount) === null || _item$benefits$$fixed === void 0 ? void 0 : _item$benefits$$fixed.amount
          };
        });
        showCoupon.value = true;
        promotions.value = findOptimalPromotion(promotionList, Number((_props$price = props.price) === null || _props$price === void 0 ? void 0 : _props$price.total));
        emit('update:promotions', promotions.value);
      } catch (error) {
        console.error(error, 'getPromotionInfosByPromotionIds---api---error');
      }
    };
    const getPromotions = async () => {
      try {
        var _PromotionsData$promo;
        const promotionsIds = [];
        const {
          data: PromotionsData
        } = await getNewCustomerPromotions({
          encryptedMarketplaceId: ENCRYPTED_MARKETPLACE_ID
        });
        PromotionsData === null || PromotionsData === void 0 ? void 0 : (_PromotionsData$promo = PromotionsData.promotions) === null || _PromotionsData$promo === void 0 ? void 0 : _PromotionsData$promo.forEach(item => {
          if (item.status === COUPON_SERVICE_PROMOTION_STATUS.ACTIVE) {
            promotionsIds.push(item.promotionId);
          }
        });
        promotionIds.value = promotionsIds;
      } catch (error) {
        console.error(error, 'getNewCustomerPromotions---api---error');
      }
    };
    const getIsNewCustomer = async () => {
      try {
        if (await isLoginAuthenticated(false)) {
          const {
            data
          } = await getCustomerActualPurchase();
          if (data.hasActualPurchase === false) {
            cptIsNewCustomer.value = true;
            getPromotions();
          }
        }
      } catch (error) {
        console.error(error, 'getCustomerActualPurchase---api---error');
      }
    };
    watch(() => {
      var _props$price2;
      return [(_props$price2 = props.price) === null || _props$price2 === void 0 ? void 0 : _props$price2.total, promotionIds.value];
    }, async valueArray => {
      if (valueArray[0] && valueArray[1].length > 0 && cptIsNewCustomer.value) {
        await getPromotionInfo(valueArray[1]);
      }
    }, {
      immediate: true
    });
    const redeemCoupon = async item => {
      try {
        await redeemPromotionForCurrentCustomer({
          encryptedPromotionId: item.id,
          encryptedMarketId: encryptedMarketplaceId
        });
        showCoupon.value = false;
        emit('updatePurchase');
        await getPromotions();
      } catch (error) {
        console.error(error, 'redeemPromotionForCurrentCustomer---api---error');
      }
    };
    onMounted(() => {
      getIsNewCustomer();
    });
    return (_ctx, _cache) => {
      var _props$price$total, _promotions$value, _props$price$promoti, _props$price$discoun, _props$price$importF, _props$price$origina, _props$price$shippin;
      const _component_van_icon = _resolveComponent("van-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('modules.checkout.TOTAL_AMOUNT_OF_PRODUCTS')), 1), _createElementVNode("div", _hoisted_4, [_createElementVNode("span", {
        class: _normalizeClass(["price", {
          'is-loading': __props.isLoading
        }])
      }, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$total = __props.price.total) === null || _props$price$total === void 0 ? void 0 : _props$price$total.toFixed(2)), 3)])]), (_promotions$value = promotions.value) !== null && _promotions$value !== void 0 && _promotions$value.text && showCoupon.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('modules.checkout.NEWCOMER_COUPON_FOR_ALL_MERCHANTS')) + " " + _toDisplayString(_unref(t)('common.FULL_REDUCTION_COUPON', {
        amount: promotions.value.threshold,
        promotion: promotions.value.amount
      })), 1)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("span", {
        class: "goTicket",
        onClick: _cache[0] || (_cache[0] = $event => redeemCoupon(promotions.value))
      }, [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.COUPON_DEDUCTION')) + " ¥" + _toDisplayString(promotions.value.amount), 1), _createVNode(_component_van_icon, {
        name: "arrow"
      })])])])) : _createCommentVNode("", true), ((_props$price$promoti = __props.price.promotionList) === null || _props$price$promoti === void 0 ? void 0 : _props$price$promoti.length) > 0 && __props.price.discount > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, " -" + _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$discoun = __props.price.discount) === null || _props$price$discoun === void 0 ? void 0 : _props$price$discoun.toFixed(2)), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.CSF')) + " ", 1), _createElementVNode("img", {
        class: "question import-fee-question",
        onClick: _cache[1] || (_cache[1] = $event => clickHandle(_unref(popUpType).CSF_DESC)),
        src: GREY_TIP,
        alt: ""
      })]), _createElementVNode("div", _hoisted_15, [_createElementVNode("span", {
        class: _normalizeClass(["price", {
          'is-loading': __props.isLoading
        }])
      }, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$importF = __props.price.importFee) === null || _props$price$importF === void 0 ? void 0 : _props$price$importF.toFixed(2)), 3)])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [_createTextVNode(_toDisplayString(_unref(t)('modules.checkout.SHIPPINGFEE')) + " ", 1), _createElementVNode("img", {
        class: "question shipping-fee-question",
        onClick: _cache[2] || (_cache[2] = $event => clickHandle(_unref(popUpType).SHIPPING_FEE_DESC)),
        src: GREY_TIP,
        alt: ""
      })]), _createElementVNode("div", _hoisted_18, [__props.addressInfo ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [__props.price.originalShippingFee !== __props.price.shippingFee ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('modules.checkout.REDUCED_SHIPPING_FEE_FOR_ORDERS_OVER_THESHOLD')), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$origina = __props.price.originalShippingFee) === null || _props$price$origina === void 0 ? void 0 : _props$price$origina.toFixed(2)), 1)], 64)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: _normalizeClass(["price", {
          'red-price': __props.price.originalShippingFee !== __props.price.shippingFee,
          'is-loading': __props.isLoading
        }])
      }, _toDisplayString(_unref(t)('common.currencyUnit')) + _toDisplayString((_props$price$shippin = __props.price.shippingFee) === null || _props$price$shippin === void 0 ? void 0 : _props$price$shippin.toFixed(2)), 3)], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_unref(t)('modules.checkout.VIEW_AFTER_SELECTING_AN_ADDRESS')), 1))])]), _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(t)('modules.checkout.UNABLE_PROVIDE_INVOICES_GLOBAL_STORE_PURCHASES')), 1), (_openBlock(), _createBlock(_Teleport, {
        to: "#app"
      }, [_createVNode(PopUp, {
        class: "spc-text-pop",
        show: show.value,
        "onUpdate:show": _cache[3] || (_cache[3] = $event => show.value = $event),
        content: popText.content,
        title: popText.title,
        btnConfirmText: _unref(t)('modules.checkout.I_UNDERSTAND')
      }, null, 8, ["show", "content", "title", "btnConfirmText"])]))]);
    };
  }
};